import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const PrivateRoutes = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const loggedIn = useSelector((state) => state.user.loggedIn);

  const isAdminRoute = searchParams.has('admin', 'true');

  const returnUrl = location.pathname ? location.pathname.replace(/\//, '?') : '';
  const redirectPath = isAdminRoute ? `/admin${returnUrl}` : `/login${returnUrl}`;

  return loggedIn ? <Outlet /> : <Navigate to={redirectPath} />;
};

export default PrivateRoutes;
